import { useMutation } from "@apollo/client";
import { UPDATE_PERMISSION } from "../../../graphql/mutations/users/permissions.users.mutation";

const useUpdatePermission = () => {
  const [updatePermissionMutation, { loading, error }] =
    useMutation(UPDATE_PERMISSION);

  const updatePermission = async (permission) => {
    try {
      // Split tags by comma and trim white space
      if (permission.tags) {
        permission.tags = permission.tags.split(",").map((tag) => tag.trim());
      }
      const response = await updatePermissionMutation({
        variables: { permission },
      });
      return response.data.updatePermission;
    } catch (error) {
      console.error({ error });
      return error;
    }
  };

  return { updatePermission, loading, error };
};

export default useUpdatePermission;
